import { render, staticRenderFns } from "./Activityaction.vue?vue&type=template&id=4938f9bc&scoped=true&"
import script from "./Activityaction.vue?vue&type=script&lang=js&"
export * from "./Activityaction.vue?vue&type=script&lang=js&"
import style0 from "./Activityaction.vue?vue&type=style&index=0&id=4938f9bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4938f9bc",
  null
  
)

export default component.exports